/**
 * 用户账户相关
 */
import api from '@/api'

let account = {}

account.info = async function () {
    return api.post(`/account/info`)
}
// account.info = info



account.setPassword = async function (data) {
    return api.post(`/account/password/set`, data)
}
account.getAccessKey = async function () {
    return api.get(`/account/accessKey/get`)
}

account.setHBAccessKey = async function (data) {
    return api.post(`/account/accessKey/setHB`, data)
}

account.setBAAccessKey = async function (data) {
    return api.post(`/account/accessKey/setBA`, data)
}

export default account
